/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { DisplayRef, DisplayRef$inboundSchema } from "./displayref.js";

/**
 * Trendable data points for a given device.
 */
export type DeviceTrendPoints = {
  /**
   * The alias of the device.
   */
  alias: string;
  /**
   * All display refs.
   */
  allDisplayRefs: Array<DisplayRef>;
  /**
   * The default set of display refs, includes Display Template Metrics + Mode.
   */
  defaultDisplayRefs: Array<DisplayRef>;
  /**
   * Universally unique identifier
   */
  deviceId: string;
  /**
   * The display name of the device.
   */
  displayName: string;
  /**
   * The kind of the device.
   */
  kind: string;
};

/** @internal */
export const DeviceTrendPoints$inboundSchema: z.ZodType<
  DeviceTrendPoints,
  z.ZodTypeDef,
  unknown
> = z.object({
  alias: types.string(),
  all_display_refs: z.array(DisplayRef$inboundSchema),
  default_display_refs: z.array(DisplayRef$inboundSchema),
  device_id: types.string(),
  display_name: types.string(),
  kind: types.string(),
}).transform((v) => {
  return remap$(v, {
    "all_display_refs": "allDisplayRefs",
    "default_display_refs": "defaultDisplayRefs",
    "device_id": "deviceId",
    "display_name": "displayName",
  });
});

export function deviceTrendPointsFromJSON(
  jsonString: string,
): SafeParseResult<DeviceTrendPoints, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceTrendPoints$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceTrendPoints' from JSON`,
  );
}
